<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog max-width="500" persistent v-model="$store.getters.loginModal">
            <v-card>
                <v-card-title class="white--text primary">
                    <h4>Είσοδος</h4>
                </v-card-title>
                <br/>
                <v-form class="mx-2" v-if="!showOtp">
                    <v-row justify="center"  class="mx-auto pb-2">
                        <v-chip v-if="errorMessageFlag"  color="error">{{errorMessage}}</v-chip>
                    </v-row>
                    <v-text-field
                            class="pt-4"
                            :error="errorMessageFlag"
                            v-model="username"
                            label="Όνομα Χρήστη"
                            name="Username"
                            prepend-icon="person"
                    ></v-text-field>
                    <v-text-field
                            :error="errorMessageFlag"
                            v-model="password"
                            label="Κωδικός Πρόβασης"
                            name="Password"
                            prepend-icon="lock"
                            :type="showPassWord ? 'text' : 'password'"
                            :append-icon="showPassWord ? 'visibility_off' : 'visibility'"
                            @click:append="showPassWord = !showPassWord"></v-text-field>
                    <v-card-actions>
                        <v-btn block class="white--text" color="primary" large primary @click="login()">ΣΥΝΔΕΣΗ</v-btn>
                    </v-card-actions>
                    <v-card-subtitle>
                        <p subtitle-2>Σε περίπτωση που ξεχάσατε το password πατήστε <a
                                href="https://submit.eudoxus.gr">εδώ</a>.</p>

                    </v-card-subtitle>
                </v-form>
                <v-container v-if="showOtp">
                    <v-row justify="center" align="center">
                        <v-col cols="12" class="text-center">
                            <v-sheet elevation="2" class="progress-bar-wrapper">
                                <!-- Dynamic progress bar with color change -->
                                <v-progress-linear
                                        :value="percentage"
                                        :color="progressBarColor"
                                        striped height="10"
                                ></v-progress-linear>

                                <v-row justify="center" class="mt-4 otp-container">
                                    <!-- Vuetify OTP Input Component -->
                                    <v-otp-input @finish="otpLogin" v-model="otp" dense length="6" type="number"></v-otp-input>
                                    <v-alert icon="info" dense class="mt-4"
                                             outlined shaped text color="lightSeaGreen"
                                    >Ένας κωδικός θα αποσταλεί σύντομα στο e-mail του λογαριασμού σας</v-alert>
                                </v-row>

                            </v-sheet>

                            <!-- Start Countdown Button -->
                            <!--                            <v-btn @click="startTimer" :disabled="isRunning" color="primary" class="mt-4">-->
                            <!--                                Start Countdown-->
                            <!--                            </v-btn>-->
                        </v-col>
                    </v-row>

                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import requests from '../requests'
    import utils from '../utilities'
    import {eventBus} from "../main";

    export default {
        name: "LoginModal",
        data() {
            return {
                dialog: true,
                username: '',
                password: '',
                errorMessageFlag: false,
                errorMessage: '',
                homeInformation: {},
                showPassWord:false,
	            showOtp:false,
	            totalTime: 110, // Total countdown time in seconds (2 minutes)
	            timeLeft: 110,
	            timer: null,
	            isRunning: false,
	            otpToken:'',
	            otp:'',
            }
        },

	    computed: {
		    // Computes the percentage for the progress bar
		    percentage() {
			    return (this.timeLeft / this.totalTime) * 100;
		    },
		    // Dynamically sets the color of the progress bar based on the remaining time
		    progressBarColor() {
			    if (this.timeLeft > 55) {
				    return 'lightSeaGreen'; // From 1 to 2 minutes
			    } else if (this.timeLeft > 25) {
				    return 'goldColor'; // From 30 seconds to 1 minute
			    } else {
				    return 'indianRed'; // From 0 to 30 seconds
			    }
		    },
	    },

	    methods: {

        	startTimer() {
			    if (this.isRunning) return;
			    this.isRunning = true;
			    this.timeLeft = this.totalTime;
			    this.timer = setInterval(() => {
				    if (this.timeLeft > 0) {
					    this.timeLeft--;
				    } else {
					    this.reset();
					    this.showOtp = false;
					    this.totalTime = 110;
					    this.timeLeft = 110;
					    this.timer = null;
					    this.isRunning = false;
				    }
			    }, 1000);
		    },

		    reset() {
			    clearInterval(this.timer);
			    this.isRunning = false;
			    this.totalTime =  110;
			    this.timeLeft =  110;
			    this.timer =  null;
			    this.isRunning =  false;
			    this.showOtp = false;
			    this.otpToken = '';
			    this.otp = '';
			    this.username = '';
                this.password = '';
		    },

		    login() {
                if (this.validateTextField()) {
                    this.$store.commit('setLoadingModal', true);
                    requests.login(this.username, this.password , this.loginBeforeOtpCallBack, this.failedLoginCallBack);
                }
            },

		    loginBeforeOtpCallBack(response){
			    // this.otpToken = response;
			    utils.setLocalStorage('cmt_token', response);// set it temporarily here, it's a token only for otp, it's not admin token, but i set it here only for the reusable request that follows
			    this.startTimer();
			    this.showOtp = true;
			    this.$store.commit('setLoadingModal', false);
		    },

		    otpLogin(){
			    this.$store.commit('setLoadingModal', true);
			    let reqObj = {"otp":this.otp}
			    requests.post('rest/user/login-otp', reqObj, this.loginCallBack)
		    },

            loginCallBack(response){
	            this.reset();
                this.errorMessageFlag = false;
                this.showPassWord = false;
                this.errorMessage = '';
                var token = response;
                utils.setLocalStorage('cmt_token', response);
                if (response == '') {//is not connected
                    this.errorMessage = 'Username or Password is incorrect';
                    this.errorMessageFlag = true;
                    this.$store.commit('setLoadingModal', false);
                }
                else {//connected
                    requests.homePageInformation(token, this.homePageInformationCallBack);
                    requests.put('rest/books/publishers', null, this.getPublishersCallBack);
                }
            },


            getPublishersCallBack(resp){
                this.$store.commit('setPublishersForSelector', resp);
            },


            failedLoginCallBack(response){
                this.errorMessage = 'Username or Password is incorrect';
                this.errorMessageFlag = true;
                this.$store.commit('setLoadingModal', false);
            },

            homePageInformationCallBack(response) {
                // utils.checkIfAllocator(response);
                this.homeInformation = response;
                this.$store.commit('setHomePageInformation', response);
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setLoginModal', false);

            },

            validateTextField() {
                this.errorMessageFlag = false;
                this.errorMessage = '';

                if (this.username.trim() == '') {
                    this.errorMessage = 'Username';
                    this.errorMessageFlag = true;
                }
                if (this.password.trim() == '') {

                    if (this.errorMessage != '') {
                        this.errorMessage += ' and Password';
                    }
                    else {
                        this.errorMessage = 'Password'
                    }
                    this.errorMessageFlag = true;
                }
                if (this.errorMessageFlag) {
                    this.errorMessage += ' is Required';
                    return false;
                }
                return true;
            }
        }
    }
</script>

<style scoped>
    .progress-bar-wrapper {
        position: relative;
        padding: 20px;
    }

    .v-progress-linear {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    .otp-container {
        display: flex;
        justify-content: center;
    }
</style>